export default "Review on the way ...\n\n<!-- Diana & Rasmus -->\n<!-- Very good room. Good atmosphere and challenging puzzles.  -->";